import { useLocation } from "react-router-dom";

const useFirstPathSegment = () => {
  const location = useLocation();
  const match = /^\/([\w-]+)(?:\/|$)/.exec(location.pathname);
  return match && match[1];
};

export { useFirstPathSegment };
